var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('nav',{staticClass:"mt-5",attrs:{"aria-label":"breadcrumbs"}},[_c('b-breadcrumb',_vm._l((_vm.breadcrumbs),function(breadcrumb){return _c('b-breadcrumb-item',{key:breadcrumb.id,staticClass:"focus-only",attrs:{"text":breadcrumb.text,"to":breadcrumb.href,"active":breadcrumb.active}})}),1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }